import { FileQuestion } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, EmptyState } from '@/components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Card>
      <EmptyState
        icon={<FileQuestion className="size-10" />}
        title="Page not found"
        description="The page you were looking for does not exist, or you do not have access to it."
        action={
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to dashboard
          </Button>
        }
      />
    </Card>
  );
}
